import React from 'react';
import { Link } from 'react-router';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import Block from '../../../ui/block';
import Page from '../../../page';
import classes from './public-api.scss';
export const PublicApi = ({
  isApiPaymentMethodCard,
  children
}) => {
  return /*#__PURE__*/React.createElement(Page, {
    showCategories: false,
    doNotUseSticky: true
  }, isApiPaymentMethodCard && /*#__PURE__*/React.createElement(Block, {
    className: classes.linksBlock
  }, /*#__PURE__*/React.createElement("ul", {
    className: classes.publicApiLinks
  }, /*#__PURE__*/React.createElement(Link, {
    to: APP_ROUTES.ACCOUNT_API_SETTINGS,
    className: classes.link,
    activeClassName: classes.active
  }, "API settings"), /*#__PURE__*/React.createElement(Link, {
    to: APP_ROUTES.ACCOUNT_API_PAYMENT,
    className: classes.link,
    activeClassName: classes.active
  }, "Payment settings"))), children);
};